import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
    marginBottom: '0.75rem',
};

const SubscriptionSection = () => {
    return (
        <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
            <Typography paragraph>
                The Subscription Page presents all available subscription plans in a detailed and visually clear format.
            </Typography>

            {/* Key Components */}
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                Key Components
            </Typography>
            <ul style={{ paddingLeft: '1.25rem' }}>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Plan Details Display:</strong> Each plan (Free, Basic, Standard, and Contact Sales) is listed with its name, features, and associated cost
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Subscribe Now Button:</strong> Allows users to subscribe to a plan with a single click.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Clear Plan Differentiation:</strong> Visual elements such as icons or tags help differentiate between plans.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Pricing Information:</strong> Transparent pricing for each available plan.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Subscription Duration:</strong> Specifies whether a plan is monthly, annual, or custom.
                    </Typography>
                </li>
            </ul>

            {/* User Interaction */}
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                User Interaction
            </Typography>
            <ul style={{ paddingLeft: '1.25rem' }}>
                <li style={listItemStyle}>
                    <Typography variant="body1">Browse the available plans.</Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">Compare features, durations, and pricing.</Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">Click Subscribe Now to subscribe.</Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">For any technical queries or payment-related concerns, please reach out to <b>support@watchnod.com</b>.</Typography>
                </li>
            </ul>
            <Typography variant="body1" color="text.secondary" >
                Note: After a plan expires, WatchNod retains its monitoring data for 7 days only. After this, all data is permanently deleted.
            </Typography>
        </Box>
    );
};

export default SubscriptionSection;
